/**
 * @internal
 */
export enum ColliderShapeChangeFlag {
  Property = 0x1,
  Count = 0x2,
  Both = Property | Count
}
